namespace advisorop.components.advisor {
    
    export class RiskMonitorDashboardController{
        $router;
        accountStatus: number;
        
        showTasksRiskMonitor: boolean;
        
        constructor(private identityService: services.IdentityService,
            private advisorService: services.AdvisorService) {            
            this.showTasksRiskMonitor = true; 
        }
        
        $onInit(): void {
            this.showTasksRiskMonitor = true;                   
        }

        $routerOnActivate(next, previous) {
        }        

    }



    class RiskMonitorDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ["identityService", "advisorService", RiskMonitorDashboardController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/risk-monitor-dashboard.html';            
        }
    }
    angular.module(Constants.APP).component("riskMonitorDashboard", new RiskMonitorDashboard());
    
}